import React from "react";
import Svg from "../../../components/Svg/Svg";
import { SvgProps } from "../../../components/Svg/types";

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 30 30" {...props}>
      <image id="image0" width="30" height="30" x="0" y="0"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAQAAACROWYpAAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAA
              DdcAAA3XAUIom3gAAAAHdElNRQfmAhcHNTutslNuAAACgklEQVQ4y42UzW+UVRSHnzudoZCCxdJC
              EKo2VGwpUALRRD6CNX7EJlpUXLgghKQ7DSFBA2FlXHVBaF3wF9CAjdECCQ1i/BawEGs1oUoCQqga
              Ap0aSoHWdOZx0Wlo35npzG9z7zm/8+Te99x730BEJljOBrZSRyUl3GOQfr7lckiSpRBBl7KLRgbp
              5TJDpCijmkbWEec4p8I4+eXTHvcja50TyZe7xS7bLM+PNnjGVhN53CoPe9iFuc0n7HbHLNvCBXZ4
              0LnZRqkfut9SZpWVdvq2IZqus8sVFJDB5z3i4qk4lhk38ifXC8FB+viPxmz4QkgVgiGM0MsLUbiG
              q4VRAH5jTRR+hJEi4VtUReE0JUXC0zQFJ6kokljEcBS+Rk2R8FNcmZrGM+OvNBjjVSr4kcEwESVM
              UM+z9NNHI71Rc71HbDBpymHbrZl+i4y7wc+9b8qzLrXT1dFt/02acgaI8Sh7OMozU7hxWviUN5hH
              jJ+oYYx/oivHPeC7vuKIqmnP+3jGec6/nNSA9R5wtzGicqOfucR93suUHrIELPP7THzTN11uj6ty
              NNE5HvMt59vmmKq3fRJscVzVpK3G3OvHec7Al/3Cuc73fUdMO+52sN0J095wmwmXedb6XJcE4Bv+
              pSWM0sFLdHKJCWCUX2iniZNMsJPv+CPv+dvkJy7KzCucB5a7IBOvtNuVM+tndu5nkjRNdjMMhwcQ
              7oS7kx3hdS7O+uINvujRh3+KaU6dJ2Z+b9bKQX5giF1ZaCkf8FX4nUKy2q9tjuTe85hlBVEAN3va
              TWbetwlb7LE2V2XIAcd4jZ2c4wy3eYxm1tLBuWBRMFhCLe+wlQpu8SVdDIZ0rrr/AXMtTraQP58B
              AAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIyLTAyLTIzVDA0OjUzOjU5KzAzOjAwPpgUOAAAACV0RVh0
              ZGF0ZTptb2RpZnkAMjAyMi0wMi0yM1QwNDo1Mzo1OSswMzowME/FrIQAAAAbdEVYdGljYzpjb3B5
              cmlnaHQAUHVibGljIERvbWFpbraRMVsAAAAidEVYdGljYzpkZXNjcmlwdGlvbgBHSU1QIGJ1aWx0
              LWluIHNSR0JMZ0ETAAAAFXRFWHRpY2M6bWFudWZhY3R1cmVyAEdJTVBMnpDKAAAADnRFWHRpY2M6
              bW9kZWwAc1JHQltgSUMAAAAASUVORK5CYII=" />
    </Svg>
  );
};

export default Icon;
